'use client';

import { formInputField } from '@lib/form/helper';
import { InputField } from '@tuic/web-compositions/core/InputField';

import type { AnyFieldApi } from '@tanstack/react-form';
import type { FC, ReactNode } from 'react';

export type ManifestInputFieldProps = {
  field: AnyFieldApi;
  label?: ReactNode;
  note?: ReactNode;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  type?: 'text' | 'email' | 'number' | 'tel' | 'url' | 'password';
  placeholder?: string;
  autoComplete?: string;
  maxLength?: number;
};

export const ManifestInputField: FC<ManifestInputFieldProps> = ({
  field,
  label,
  note,
  required,
  disabled,
  className,
  type,
  placeholder,
  autoComplete,
  maxLength = 55,
}) => (
  <InputField
    {...formInputField(field)}
    label={label}
    note={note}
    required={required ? 'label' : undefined}
    disabled={disabled}
    className={className}
    type={type}
    placeholder={placeholder}
    autoComplete={autoComplete}
    maxLength={maxLength}
  />
);
